import { Component, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { Paciente, SignosVitales } from '../../pacientes/pacientes';

@Component({
  selector: 'app-historial-signos-vitales-dialog',
  standalone: true,
  imports: [DatePipe, MatButtonModule, MatIconModule, MatTableModule],
  templateUrl: './historial-signos-vitales-dialog.html',
  styleUrl: './historial-signos-vitales-dialog.scss',
})
export class HistorialSignosVitalesDialog {
  columnas = ['fecha', 'peso', 'talla', 'fc', 'fr', 'sato2', 'temperatura', 'ta', 'observaciones'];

  constructor(
    private dialogRef: MatDialogRef<HistorialSignosVitalesDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: { paciente: Paciente; signosVitales: SignosVitales[] },
  ) {}

  cerrar(): void {
    this.dialogRef.close();
  }

  dato(valor: unknown, unidad = ''): string {
    const texto = `${valor ?? ''}`.trim();
    return texto ? `${texto}${unidad}` : '—';
  }

  presion(sv: SignosVitales): string {
    return sv.presionSistolica != null && sv.presionDiastolica != null
      ? `${sv.presionSistolica}/${sv.presionDiastolica} mmHg`
      : '—';
  }

  // Oculta el mensaje automático del triage, igual que en la barra de resumen
  observacion(sv: SignosVitales): string {
    const texto = sv.observaciones?.trim();

    if (!texto || texto.toLowerCase() === 'signos vitales registrados durante el triage') {
      return '—';
    }

    return texto;
  }
}
